<template lang="pug">
  div(:class="{'colorTransition': formSubmitted}")
    klaviyo-form(
      :list-id="listId"
      input-class="form-area"
      :placeholderText="placeholderText"
      :button-text="submitText"
      button-class="button"
      send-event="true"
      event="success"
      @success="onFormSuccess"
    )
    transition(name="fade")
      p.newsletter-form-success(v-if="formSubmitted") {{copyConfirm}}
</template>

<script>
import KlaviyoForm from '@/scripts/components/forms/KlaviyoForm.vue'

export default {
  name: 'NewsletterSignup',
  components: { KlaviyoForm },
  props: {
    copyConfirm: {
      type: String,
      default: 'We just sent you a confirmation email!'
    },
    listId: String,
    submitText: {
      type: String,
      default: 'Submit'
    },
    placeholderText: {
      type: String,
      default: 'Email'
    }
  },
  data () {
    return {
      formSubmitted: false
    }
  },
  methods: {
    onFormSuccess () {
      this.formSubmitted = true
    }
  }
}
</script>

<style scoped lang="scss">
  .fade-enter-active {
    transition: opacity 1s; // slow fade-in on success state
  }
</style>
